import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Loading from '../../components/loading/Loading';
import { storeReferralCode } from '../../utils/referralCode';

/**
 * `/i/CODIGO`: guarda o código de indicação e segue para a landing.
 * O nome de quem indicou aparece lá (ReferralBanner) e no cadastro.
 *
 * Quem já está logado não é um cadastro novo: segue para o app sem guardar o
 * código (senão ele ficaria no navegador à espera de outra conta).
 * @param {Object} props
 * @param {boolean} props.isSessionLoaded
 * @param {boolean} props.isAuthenticated
 */
function ReferralEntry({ isSessionLoaded, isAuthenticated }) {
  const { code } = useParams();
  if (!isSessionLoaded) {
    return <Loading />;
  }
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  storeReferralCode(code);
  return <Navigate to="/" replace />;
}

export default ReferralEntry;
